import { Pipe, PipeTransform, Injectable } from '@angular/core';
@Pipe({
  name: 'dateFilter'
})
@Injectable()
export class DateFilterPipe implements PipeTransform {
  transform(dateData: any): string {
    if (!dateData) {
      return '';
    }
    let date: Date | null = null;

    if (!isNaN(dateData)) {
      const timestamp = typeof dateData === 'string' ? parseInt(dateData, 10) : dateData;
      date = new Date(timestamp * 1000);
    }
    else if (typeof dateData === 'string') {
      try {
        const [datePart, timePart] = dateData.split(' ');
        const [d, m, y] = datePart.split('-').map(Number);
        const [hour = 0, minute = 0, second = 0] = (timePart || '00:00:00').split(':').map(Number);
        date = new Date(Date.UTC(y, m - 1, d, hour, minute, second));
      } catch (e) {
        return '';
      }
    }

    if (!date || isNaN(date.getTime())) return '';

    const day = String(date.getUTCDate()).padStart(2, '0');
    const month = String(date.getUTCMonth() + 1).padStart(2, '0');
    const year = date.getUTCFullYear();


    return `${day}/${month}/${year}`;
  }
}
